import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * App frame. Sidebar owns the left column across both rows; Topbar is the
 * top of the right column; children fill the remainder. Mobile-first: 56px
 * icon-rail sidebar by default, 240px on ≥1024px viewports. See `.app-shell`
 * in globals.css for the breakpoints.
 */
export function Shell({ sidebar, topbar, children }) {
    return (_jsxs("div", { className: "app-shell", children: [_jsx("aside", { className: "app-sidebar", children: sidebar }), _jsx("header", { className: "app-topbar", children: topbar }), _jsx("main", { className: "app-main scrollbar", children: children })] }));
}
//# sourceMappingURL=Shell.js.map